<template>
  <div class="container my-5">
    <!-- Page Heading -->
    <h1 class="display-6 text-center text-success mb-4">Artificial Intelligence in Secondary Education</h1>

    <!-- Intro Section -->
    <p class="lead text-center mb-4">
      Our Computer Science curriculum includes a strong foundation in Artificial Intelligence. Whether your exam board includes AI topics or you're working on a specific project in AI, ML, or DL, we support your goals with structured, engaging learning.
    </p>

    <!-- Highlighted Note -->
    <div class="alert alert-success" role="alert">
      AI is gaining prominence across curricula. While some boards include advanced topics already, others are expanding their coverage. We ensure you're prepared — whether for exams or your own tech-driven ambitions.
    </div>

    <!-- Bootstrap Accordion for Topics -->
    <div class="accordion" id="aiAccordion">
      <div class="accordion-item" v-for="(section, index) in sections" :key="index">
        <h2 class="accordion-header" :id="`heading${index}`">
          <button
            class="accordion-button custom-accordion-header"
            :class="{ collapsed: activeIndex !== index }"
            type="button"
            data-bs-toggle="collapse"
            :data-bs-target="`#collapse${index}`"
            :aria-expanded="activeIndex === index"
            :aria-controls="`collapse${index}`"
            @click="activeIndex = activeIndex === index ? -1 : index"
          >
            {{ section.title }}
          </button>
        </h2>
        <div
          :id="`collapse${index}`"
          class="accordion-collapse collapse"
          :class="{ show: activeIndex === index }"
          :aria-labelledby="`heading${index}`"
          data-bs-parent="#aiAccordion"
        >
          <div class="accordion-body">
            <ul>
              <li v-for="(item, i) in section.items" :key="i">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- CTA -->
    <div class="text-center mt-5">
      <p class="fs-5">
        Whether you're preparing for exams or building an AI project portfolio, our tailored guidance gives you the edge you need.
      </p>
      <button class="btn btn-outline-success">Explore AI Courses</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIOverview',
  data() {
    return {
      activeIndex: 0,
      sections: [
        {
          title: 'Core AI Concepts',
          items: [
            'Artificial Intelligence: Introduction and Definitions',
            'Machine Learning & Expert Systems',
            'Deep Learning and Neural Networks',
            'Comparison of ML vs DL',
            'Chatbots and Automated Systems'
          ]
        },
        {
          title: 'AI Algorithms & Applications',
          items: [
            'Shortest Path Algorithms (Dijkstra & A*)',
            'Game AI Applications (Maze solvers, Board Game AI)',
            'Web Crawlers and Data Extraction',
            'Use of AI in Search and Recommendation'
          ]
        },
        {
          title: 'Machine Learning Models',
          items: [
            'Supervised, Unsupervised & Reinforcement Learning',
            'Semi-supervised (Active) Learning',
            'Labelled vs Unlabelled Data',
            'Regression & Classification Models',
            'Backpropagation in Neural Networks'
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.custom-accordion-header {
  background-color: #198754 !important; /* Bootstrap green */
  color: white !important;
  font-weight: 500;
}
.accordion-body ul {
  padding-left: 1.2rem;
}
</style>

